import React, { useEffect, useState } from "react";
import EditModal from "./shared/EditModal";
import { MdEdit, MdDelete } from "react-icons/md";
import SUG from "./shared/suggestions";

export default function ProjectsSection({ value = [], onChange }) {
  const [items, setItems] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);

  useEffect(() => setItems(value || []), [value]);

  // ✅ Added "Skill Set" field after domain
  const fields = [
    { name: "title", label: "Project name", type: "text" },
    { name: "domain", label: "Domain", type: "text", suggestList: SUG.domains },
    { name: "skills", label: "Skills Set", type: "text", placeholder:"Skills Set used in your project" },
    { name: "url", label: "Project URL", type: "text", placeholder: "Github url" },
    { name: "description", label: "Description", type: "textarea" },
  ];

  const openAdd = () => {
    setEditIdx(null);
    setOpen(true);
  };

  const openEdit = (i) => {
    setEditIdx(i);
    setOpen(true);
  };

  const save = (obj) => {
    const next = [...items];
    if (editIdx == null) next.push(obj);
    else next[editIdx] = obj;
    setItems(next);
    onChange(next);
  };

  const remove = (i) => {
    const next = items.filter((_, idx) => idx !== i);
    setItems(next);
    onChange(next);
  };

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Projects</h3>
        <div className="card-actions">
          <button className="link" onClick={openAdd}>Add</button>
        </div>
      </div>

      <div className="card-body">
        {items.length === 0 ? (
          <p className="muted">No projects</p>
        ) : (
          items.map((p, i) => (
            <div className="item-row" key={i}>
              <div>
                <div className="item-title">{p.title}</div>
                <div className="muted">{p.domain}</div>

                {/* ✅ Show Skill Set below domain */}
                {p.skills && (
                  <div className="muted smalll">
                    <strong>Skills:</strong> {p.skills}
                  </div>
                )}

                {/* ✅ Display Project URL below domain if available */}
                {p.url && (
                  <div className="muted">
                    <a
                      href={p.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#2563eb", textDecoration: "none" }}
                    >
                      {p.url}
                    </a>
                  </div>
                )}
              </div>

              <div className="item-actions">
                <MdEdit
                  title="Edit"
                  className="smalll"
                  onClick={() => openEdit(i)}
                />
                <MdDelete
                  title="Delete"
                  className="smalll danger"
                  onClick={() => remove(i)}
                />
              </div>
            </div>
          ))
        )}
      </div>

      {open && (
        <EditModal
          title={editIdx == null ? "Add project" : "Edit project"}
          initial={editIdx == null ? {} : items[editIdx]}
          fields={fields}
          onClose={() => setOpen(false)}
          onSave={(d) => {
            save(d);
            setOpen(false);
          }}
        />
      )}
    </section>
  );
}
